import { lazy } from '@/shared/utils/lazy';

export const Configs = lazy(
  () => import(/* webpackChunkName: "configs" */ './routes'),
  'ConfigRoutes',
);
